var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course__summary"},[_c('p',{domProps:{"textContent":_vm._s(_vm.item.preview_text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }